var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs-center pa-2 pt-5",staticStyle:{"width":"100%"}},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }